import { Components } from "@mui/material/styles";

export const MuiDialog: Components['MuiDialog'] = {
    styleOverrides: {
        paper: {
            borderRadius: 'unset' 
        },
        root: {
            '& .MuiPaper': { borderRadius: 'unset' },
            '& .MuiDialogActions-root': {
                backgroundColor: '#F2F5F8'
            },
            '& .MuiDialogContent-root': {
                marginTop: '20px'
            },
            '& .MuiDialogContent-dividers': {
                border: 'unset'
            }
        }
    }
};
